import DomainIcon from '@mui/icons-material/Domain';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { CSSProperties } from '@mui/material/styles';
import React from 'react';

import { Box } from '_lib/components/Box/Box';

import { StyledTab, StyledTabs, VerticalDivider } from '_lib/styles/PhoneCall.styled';

import { CallDetailsFooter } from '../CallDetailsFooter/CallDetailsFooter';

export const TwoTabFooter = (props: {
  tabIndex: number;
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  callDetailsWidth: CSSProperties['width'];
}) => {
  const { tabIndex, setTabIndex, callDetailsWidth } = props;

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        bgcolor: theme.palette.callPane.main,
        color: theme.palette.callPane.contrastText,
        maxHeight: '45px'
      })}>
      <Box
        sx={{
          width: callDetailsWidth,
          minWidth: '330px',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <CallDetailsFooter />
      </Box>
      <VerticalDivider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: 'fill-available',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <StyledTabs
          sx={{
            width: '100%',
            '& button': {
              paddingTop: 0,
              paddingBottom: 0
            },
            '& .MuiTabs-indicator': { display: 'none' }
          }}
          variant='fullWidth'
          value={tabIndex === 0 ? 1 : tabIndex}
          onChange={(_event: React.SyntheticEvent, newValue: number) => setTabIndex(newValue)}>
          <StyledTab
            label={'CUSTOMER'}
            id='phoneCall-tab-1'
            value={1}
            icon={<PermContactCalendarIcon fontSize='small' />}
            iconPosition='start'
          />
          <StyledTab
            label={'COMPANY'}
            id='phoneCall-tab-2'
            value={2}
            icon={<DomainIcon fontSize='small' />}
            iconPosition='start'
          />
        </StyledTabs>
      </Box>
    </Box>
  );
};
